import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { MdChevronRight, MdOutlineDescription, MdOutlineHelpOutline } from "react-icons/md";
import GiftcardHtml from "src/Modules/GiftCards/pages/GiftcardDetails/components/GiftcardHtml/GiftcardHtml";
import Carrier from "src/components/Carrier/Carrier";
import { HOW_TO_USE_KEY, TERMS_KEY } from "../../constants";

type Props = {
  usageInstructions?: string | null;
  termsAndConditions?: string | null;
  title?: ReactNode;
};

const InstructionCards: FC<Props> = ({ usageInstructions, termsAndConditions, title }) => {
  const { t } = useTranslation();
  const items = [
    {
      key: HOW_TO_USE_KEY,
      label: t("Discounts.howToUse"),
      content: usageInstructions,
      Icon: MdOutlineHelpOutline,
    },
    {
      key: TERMS_KEY,
      label: t("Discounts.termsAndConditions"),
      content: termsAndConditions,
      Icon: MdOutlineDescription,
    },
  ].filter((item) => !!item.content);

  if (!items.length) return null;

  return (
    <div className="flex w-full flex-col gap-3 text-start">
      {title && <span className="text-font-default text-sm font-semibold">{title}</span>}
      {items.map(({ key, label, content, Icon }) => (
        <Carrier
          key={key}
          label={<span className="font-semibold">{label}</span>}
          renderTrigger={({ open }) => (
            <button
              type="button"
              onClick={open}
              className="border-border-subtle bg-background-default hover:border-border-active flex w-full flex-col gap-2 rounded-xl outline outline-border-subtle p-4 text-start transition-colors"
            >
              <div className="flex w-full items-center gap-3">
                <div className="bg-background-primary-lighter text-icon-active flex h-10 w-10 shrink-0 items-center justify-center rounded-full">
                  <Icon className="h-5 w-5" />
                </div>
                <span className="text-font-default flex-1 text-sm font-semibold">{label}</span>
                <MdChevronRight className="text-icon-minimal h-5 w-5 shrink-0 rtl:-scale-x-100" />
              </div>
            </button>
          )}
          renderSheet={() => <GiftcardHtml className="text-font-default flex flex-col gap-2 p-4 text-xs" html={content} />}
        />
      ))}
    </div>
  );
};

export default InstructionCards;
